document.addEventListener('DOMContentLoaded', initializeProductSubscriptions);
  
    function initializeProductSubscriptions () {
        const subscribe_button = document.getElementById('klaviyo__subscribeToCatalog');
        subscribe_button.addEventListener('click', klaviyo__subscribeToCatalog);
    }
  
    function klaviyo__subscribeToCatalog() {
        
        const bisForm = document.querySelector('back-in-stock-form');
        const bisFormInputs = bisForm.querySelector('.customer.catalog_subscribe');
        const bisNewsletterSignup = bisForm.querySelector('input[name="SubscribeToNewsletter"]:checked');
        let enableSignup = false;
        if (bisNewsletterSignup) {
          enableSignup = true;
        } 
  
        const subscribeButton = bisForm.querySelector('back-in-stock-form button[name="backinstock"]');
        const spinner = bisForm.querySelector('.loading-overlay__spinner');
        const message = bisForm.querySelector('.subscribe.message');
        const variant_id = document.querySelector('product-form.product-form input[name="id"]').value;
        const product_id = document.querySelector('product-form.product-form input[name="product-id"]').value;
        const input_email = bisForm.querySelector('input[name="bis_email"]').value;
        const subscribe_result_success = bisForm.querySelector('.subscribe_result .subscribe_success');
        const subscribe_result_fail = bisForm.querySelector('.subscribe_result .subscribe_fail');
        const revision = '2023-09-15';
  
        if (subscribeButton.getAttribute('aria-disabled') === 'true') return;
  
        //this.handleErrorMessage();
  
        subscribe_result_success.classList.add('d-none');
        subscribe_result_fail.classList.add('d-none');
        
        subscribeButton.setAttribute('aria-disabled', true);
        subscribeButton.classList.add('loading');
        spinner.classList.remove('hidden');

  
        const options = {
          method: 'POST',
          headers: {
            accept: 'application/json',
            revision: new String(revision),
            'content-type': 'application/json'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['EMAIL'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      email: new String(input_email)
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: new String('$shopify:::$default:::' + variant_id)
                  }
                }
              }
            }
          })
        };
  
        
        fetch(url_backinstock, options)
          .then((response) => {
            if(response.ok) { 
              bisFormInputs.classList.add('d-none');
              subscribe_result_success.classList.remove('d-none');
            } else {
              subscribe_result_fail.classList.remove('d-none');
            }
          })
          .catch(err => console.error(err))
          .finally(() => {
            spinner.classList.add('hidden');
            subscribeButton.classList.remove('loading');
            subscribeButton.setAttribute('aria-disabled', false);
          });
          
          if (!enableSignup) return;
          
          
          const signupOptions = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              revision: new String(revision),
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Back in stock',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: new String(input_email)
                      }
                    }
                  }
                },
                relationships: {list: {data: {type: 'list', id: new String(klaviyo_newsletter_list_id)}}}
              }
            })
          };
  
          
  
          fetch(url_subscribe, signupOptions)
          .catch(err => console.error(err));

  
      }